import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        tooltipWrapper: {
            width: 400,
            height: 150,
            padding: theme.spacing(2),
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
        },
        wrapper: {
            display: 'flex',
            justifyContent: 'space-between',
        },
        item: {
            flexGrow: 1,
            flexBasis: 0,
        },
        label: {
            color: theme.palette.secondary[600],
            fontSize: 12,
            paddingBottom: theme.spacing(1),
        },
        marker: {
            width: 16,
            height: 16,
            borderRadius: 2,
            marginRight: theme.spacing(1),
        },
        valueWrapper: {
            display: 'flex',
            alignItems: 'center',
        },
    }
})

export default useStyles
